import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useLanguage } from '../context/LanguageContext';

const PrivacyPolicyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      <Header />
      
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-montserrat-bold text-3xl md:text-4xl text-[#0b004c] mb-8 text-center">
            {t('privacyPolicyTitle')}
          </h1>
          
          <div className="prose prose-lg max-w-none font-montserrat text-[#6a6a6a]">
            <p className="mb-6">
              <strong>{t('lastUpdated')}</strong> {t('january2025')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('privacyIntroTitle')}</h2>
            <p className="mb-4">
              {t('privacyIntroContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('privacyCollectTitle')}</h2>
            <p className="mb-4">{t('privacyCollectIntro')}</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li><strong>{t('privacyCollectPersonal')}</strong> {t('privacyCollectPersonalDesc')}</li>
              <li><strong>{t('privacyCollectUsage')}</strong> {t('privacyCollectUsageDesc')}</li>
              <li><strong>{t('privacyCollectTechnical')}</strong> {t('privacyCollectTechnicalDesc')}</li>
            </ul>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('privacyUseTitle')}</h2>
            <p className="mb-4">{t('privacyUseIntro')}</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>{t('privacyUse1')}</li>
              <li>{t('privacyUse2')}</li>
              <li>{t('privacyUse3')}</li>
              <li>{t('privacyUse4')}</li>
              <li>{t('privacyUse5')}</li>
            </ul>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('privacySharingTitle')}</h2>
            <p className="mb-4">
              {t('privacySharingContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('privacySecurityTitle')}</h2>
            <p className="mb-4">
              {t('privacySecurityContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('privacyRightsTitle')}</h2>
            <p className="mb-4">{t('privacyRightsIntro')}</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>{t('privacyRights1')}</li>
              <li>{t('privacyRights2')}</li>
              <li>{t('privacyRights3')}</li>
              <li>{t('privacyRights4')}</li>
              <li>{t('privacyRights5')}</li>
            </ul>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('privacyContactTitle')}</h2>
            <p className="mb-4">
              {t('privacyContactIntro')}
            </p>
            <p className="mb-4">
              <strong>{t('email')}:</strong> brian@datasignz.nl<br />
              <strong>{t('phone')}:</strong> +597 8545865
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
